import { Accordion } from '@mantine/core';

type Props = {
  controlIcon: React.ReactNode;
  controlTitle: string;
  children: React.ReactNode;
};

export const AccordionLayout = ({ controlIcon, controlTitle, children }: Props) => {
  return (
    <Accordion
      chevronPosition="right"
      mx="auto"
      variant="separated"
      m={'xl'}
      value={'filter-form'}
      styles={{ chevron: { display: 'none' } }}
    >
      <Accordion.Item value="filter-form">
        <Accordion.Control icon={controlIcon}>{controlTitle}</Accordion.Control>
        <Accordion.Panel>{children}</Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
};
